<template>
  <v-page-content>
    <h3><em class="fas fa-1x fa-book-open"></em> Журналы</h3>
    <b-card no-body footer-tag="footer" style="min-width: 250px">
      <b-tabs card>
        <b-tab title="Запросы" active>
          <AdminLogsTable type="info" />
        </b-tab>
        <b-tab title="Ошибки">
          <AdminLogsTable type="error" />
        </b-tab>
      </b-tabs>
    </b-card>
  </v-page-content>
</template>

<script>
import AdminLogsTable from '@/components/admin/logs/ServerLogsTable.vue'

export default {
  name: 'LogsPage',
  components: { AdminLogsTable }
}
</script>
